<template>
  <div class="home" id="home">
    <v-header v-if="notapp" :go-back="false" :if-login="islogin" :mine='true'></v-header>
   	<addpetType v-if="selpetType" @petsN='getpetType'></addpetType>
   	<v-introduction v-if="isintroduction" @introductC="introductClose"></v-introduction>
   	<v-menus v-if="menu" @menuC="menuClose" @editinfos="editInfo" @editmyinfo="editInfo3"></v-menus>
   	<v-scanningrecord v-if="scanningrecords" @cords="cordClose"></v-scanningrecord>
   	<div class="allinfo">
    	<div class="title" ref="title">
	    	<ul>
	    		<p v-if="pagestatu == 1001 || pagestatu == 1002" @click="showintroduct"><img src="../../../static/img/account2/introduction.png" alt="">{{$t('introduction.sure')}}</p>
	    		<li v-if="pagestatu == 1000">{{$t('petstatus.petinfo')}}</li>
	    		<li v-if="pagestatu == 1001">{{$t('petstatus.petlookafter')}}</li>
	    		<li v-if="pagestatu == 1002">{{$t('petstatus.petmissing')}}</li>
	    		<li v-if="pagestatu == 1003">{{$t('petstatus.petfinding')}}</li>
	    	</ul>
    	</div>
		  <div class="petinfo">
		    <div class="petinfo-main">
		      <div>
		        <div class="head_img" v-show="!ifedit">
		          <img :src="portrait" preview="1" style="margin: auto;display: block;">
		        </div>
		        <div class="head_img" v-show="ifedit">
		          <img
		            :src="imgflag?avatar:avatar1"
		            @click.stop="uploadHeadImg"
		            style="margin: auto;display: block;"
		            v-show="isshow"
		          >
		          <canvas
		            ref="can"
		            v-show="showflag1"
		            style="width:80px;height:80px;margin: auto;display: block;border-radius: 50%;"
		            @click.stop="uploadHeadImg"
		          ></canvas>
		          <input type="file" accept="image/*" @change="handleFile" class="hiddenInput">
		        </div>
		        <div class="pet">
		          <ul>
		            <li>
		              <span class="petNewsIcon"><img src="../../../static/img/account2/petNick.png" alt=""></span>
		              <p class="infoBox" v-show="!ifedit">{{petname}}</p>
		              <el-input
		                :value="petname"
		                @input="changename"
		                v-model='petname'
		                @change="Verificationname"
		                maxlength="12"
		                v-show="ifedit"
		                :placeholder="$t('addpet.entername')" 
		              ></el-input>
		              <span class="danger" v-show="flag6">{{$t('addpet.have')}}</span>
		            </li>
		            <li>
			            <span  class="petNewsIcon" @click="selpetsType(isable)" style="width:100%;"><img src="../../../static/img/account2/petType.png" alt=""></span>
			            <p v-show="!ifedit">{{petType}}</p>
			            <el-input v-model='petbelong' :value="petType" :placeholder="$t('addpet.enterType')" maxlength="8" readonly v-show="ifedit" @change="Verificationbelong" @input="changepetbelong" ></el-input>
			        	</li>
		            <li>
		              <span class="petNewsIcon"><img src="../../../static/img/account2/sex.png" alt=""></span>
		              <p v-show="!ifedit">{{value}}</p>
		              <div class="selectsex" v-show="ifedit">
		                <el-select v-model="value" :placeholder="$t('addpet.selectSex')" ref='sex'>
		                  <el-option
		                    v-for="item in options"
		                    :key="item.value"
		                    :label="item.label"
		                    :value="item.value"
		                  ></el-option>
		                </el-select>
		              </div>
		            </li>
		          </ul>
		          <span class="lossbtn" v-if="lossbtn" @click="mapready">{{$t('lossinfo.sure')}}</span>
		        	<span class="lossbtn" v-if="closebtn" @click="closepublish">{{$t('lossinfo.close')}}</span>
		        </div>
		      </div>
		    </div>
    		<div class="lostsign" v-if="lostsign">
        	<img v-if="lang=='zh'" src="../../../static/img/petlosted.png" alt="" />
        	<img v-if="lang=='en'" src="../../../static/img/petlosteden.png" alt="" />
        	<img v-if="lang=='ja'" src="../../../static/img/petlostedja.png" alt="" />
        	<li>
        		<span v-for="item in losttime.slice(0,10)">{{item}}</span>
        	</li>
        </div>
		  </div>
		<div class="mynews">
      <div class="new">
        <span class="title" v-show="false">{{$t('mynews.masternews')}}</span>
			<div class="news">
				<div class="pos"><span><img src="../../../static/img/account2/nick.png" alt=""></span>
					<input :disabled="isable" v-model="nc" maxlength="12" ref='name'  :placeholder="$t('mynews.mastername')" >
				</div>
				<div class="pos"><span><img src="../../../static/img/account2/email.png" alt=""></span>
					<input :disabled="isable" v-model="em" >
				</div>
				<div class="pos"><span><img src="../../../static/img/account2/phone.png" alt=""></span>
					<input :disabled="isable" v-model="phone"> 
				</div>
				<div class="pos"><span><img src="../../../static/img/account2/addr.png" alt=""></span>
					<input :disabled="isable" v-model="adr">
				</div>
			</div>
      </div>
		</div>
    </div>
    <el-button v-if="activations" type="primary" style='margin:50px auto;display: block;width: 75%;' @click='save'>{{$t('releaseSearch.preserve')}}</el-button>
    <el-button v-if="activations" type="primary" style='margin:50px auto;display: block;width: 75%;    margin-top: -30px;' @click='cancel'>{{$t('releaseSearch.cancel')}}</el-button>
   	<v-lostpetinfo v-if="lostpetinfos"  @editinfoss="editInfo2" :message='featurePhoto' @Gotop='gotop'></v-lostpetinfo>
		<div class="menus" v-if="menus" @click="editMenus">
			<img :src="menuimg" alt="" />
		</div>
		
		
		<div class="loadimg" v-if="loadimg">
  		<img src="../../../static/img/reload.gif" alt="" />
  	</div>
  </div>
  
  
</template>
<script >
import EXIF from "exif-js/exif.js";
import { getDevices } from "../../deviceApi/index.js";
import header from "../../components/header";
import store from "../../store/store.js";
import addpetType from "../myAccount/addpetType"
import lostpetinfo from "../myAccount/lostpetinfo";
import menus from "../home/menus";
import choosePet from "../../components/choosePet";
import adddeviceType from "../home/adddeviceType";
import introduction from "../login/introduction";
import scanningrecord from "../login/scanningrecord";
import { getLoginUser} from "../../api/index.js";
import BMap from "BMap";
import { bind,add_pet,bind_pet,updateBasicInfo,unbind,index,getuserinfo,weixinshare} from "../../apiNew/index.js";
import Qs from "qs";
import { getpet,addPet,addPublish,updatePublish,updatePet,addScanner} from "../../ClientServerApi/index.js";
export default {
  name: "showInformation",
  data() {
    return {
    	lang:localStorage.getItem('locale'),
      islogin: true,
      infos: "",
      notapp:true,
      loginsuccess: false,
      loginshowflag: true,
      getToken: sessionStorage["token"],
      imei: "",
      menus:false,//右下角菜单按钮
      menu:false,
      lossbtn:false,//发布走失按钮
      closebtn:false,
      losttime:[],
      lostsign:false,//走失标志
      lostpetinfos:false,//走失宠物信息组件
      lostPlace:"",//默认走失地点
      myplace:"",//我当前的位置
      publishId:"",//发布协寻id
      activations:false,
      scanningrecords:false,//扫码记录组件
      isintroduction:false,//简介组件
      addDeviceBtn: false,
      deviceCode: "", //获得点击的设备devicedCode
      pagestatu:1001,//页面登录状态属性
      ifedit: false,//宠物信息是否可以编辑
      isable:true,//主人信息输入框
      petname: "",
      petType: "",
      gender: "",
      value: "",
      loadimg:false,
      selpetType: false,//品种选择
      petbelong: "",
      portrait: "",
      portrait1: "",
      preserve:false,//更新主人，宠物信息保存按钮
      height:1,
      weight:1,
      birthday:"2019-07-01",
      color:"white",
      character:"good",
      petId:"",
      fristpublish:false,
      Id:"",
      nc: "",
      em: "",
      phone: "",
      adr: "",
      options: [
        {
          value: this.$t("prompt.boy"),
          label: this.$t("prompt.boy")
        },
        {
          value: this.$t("prompt.girl"),
          label: this.$t("prompt.girl")
        }
      ],
      featurePhoto:[],
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6:false,
      flag7: false,
      flag8: false,
      flag9: false,
      flag10: false,
      flag11: false,
      scrollY:0,
      showflag: false,
      showflag1: false,
      isshow: true,
      imgflag: false,
      avatar: "",
      avatar1: require("../../../static/img/headerbg.png"),
      menuimg: require("../../../static/img/menuss.png"),
    };
  },
  mounted() { 
		this.weixinshare();
  },
  inject:["reload"], 
  created() {
    	//this.unbind();//解绑设备
  	if(localStorage.fromapp){//是否在app内打开
  		this.notapp=false;
  	}
		this.index();
    //查询本地是否有token，有则自动登录，若没有则检查session是否
		let accessToken = this.GetQueryString("accessToken");
		localStorage.setItem('token',accessToken);
		this.$store.commit("set_token", accessToken);
		let codeid = this.GetUrlParam("deviceCode");
		if(codeid != ''){
			localStorage.setItem('codeId',codeid);
		}
    var geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(
      function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          sessionStorage.setItem("lng", r.point.lng);
          sessionStorage.setItem("lat", r.point.lat);
        } else {
          alert("failed" + this.getStatus());
        }
      },
      {
        enableHighAccuracy: true
      }
    );
  },
  watch:{
 			petbelong(newvalue, oldvalue){
        this.$nextTick(function() {
				localStorage.setItem('petbelong',newvalue);
				})
      },
 			petname(newvalue, oldvalue){
 				let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression")+ "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.petname=	oldvalue;
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('petname',newvalue);
				})
     },
     value(newvalue, oldvalue){
        this.$nextTick(function() {
					localStorage.setItem('value',newvalue);
				})
     },
     em(newvalue, oldvalue){
     		let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression")+ "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.em=	oldvalue;
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('em',newvalue);
				})
     },
     phone(newvalue, oldvalue){
     		let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression")+ "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.phone=	oldvalue;
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('phone',newvalue);
				})
     },
     adr(newvalue, oldvalue){
     		let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.adr=	oldvalue;
						return false;
 				}
     	
        this.$nextTick(function() {
					localStorage.setItem('adr',newvalue);
				})
     },
     nc(newvalue, oldvalue){
     		let filter =this.filter(newvalue);
 				if(filter==true){
						this.$alert("<p>" + this.$t("prompt.noexpression") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
						this.nc=	oldvalue;	
						return false;
 				}
        this.$nextTick(function() {
					localStorage.setItem('nc',newvalue);
				})
     }
   
  },
  methods: {
//====微信分享======
	weixinshare(){
			var params = Qs.stringify({
						url: location.href.split('#')[0],
				});
				weixinshare(params)
				 .then(res => {
				 		this.initWx(res.data.timestamp, res.data.nonceStr, res.data.signature);
				 })
				 .catch(error => {
		      console.log(error);
		    });	
	},
initWx(timestamp, nonceStr, signature){
	console.log(this)
		var th = this;
		wx.config({
		    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
		    appId: 'wxb595c21e93322a1a', // 必填，公众号的唯一标识
		    timestamp: timestamp, // 必填，生成签名的时间戳
		    nonceStr: nonceStr, // 必填，生成签名的随机串
		    signature: signature,// 必填，签名
		    jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
		});
		wx.ready(function(result){
		    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
		    // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，
		    // 则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
			th.onShare();
		});
		wx.error(function(result){
		    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
		    //alert('error: ' + JSON.stringify(result));
		});
	},
onShare(){
	    wx.onMenuShareTimeline({
			title: localStorage.content, // 分享标题
			link: 'http://h5cn.dognessnetwork.com/jump?id='+this.GetUrlParam("deviceCode"), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致  http://apicn.dognessnetwork.com
			imgUrl: this.portrait, // 分享图标
			success: function () {
				// 用户点击了分享后执行的回调函数
			},
			cancel: function () { 
	        // 用户取消分享后执行的回调函数
	    },
			fail: function (res) {
                //alert(JSON.stringify(res));
            },
			trigger: function (res) {
				// 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
            },
		}),
    wx.onMenuShareAppMessage({
      title: this.$t('login.platform'), // 分享标题
      desc: localStorage.content, // 分享描述
      link: 'http://h5cn.dognessnetwork.com/jump?id='+this.GetUrlParam("deviceCode"),  // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: this.portrait, // 分享图标
      type: "", // 分享类型,music、video或link，不填默认为link
      dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户确认分享后执行的回调函数
        //_this.$vux.toast.text('分享成功！！！');
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
        //_this.$vux.toast.text('取消分享！！！');
      }
    })

		
	},

//我的吊牌跳转到本页面
  	tagshow(){
  		if(localStorage.codeId){
  				let code = localStorage.codeId;
  				var params = Qs.stringify({
							deviceCode: code,
					});
					index(params)
			    .then(res => {
							//console.log("我是主人查看吊牌返回数据：",res);
              if (res.data.header.status == 1000) {
              	  this.ifedit = false;//宠物信息是否可以编辑
						  		this.isable = true;//禁止编辑主人信息
						  		this.menus = true;
						  		if(res.data.data.pet.portrait==''){
						  			this.portrait=require("../../../static/img/headerbg.png");
						  			this.avatar =require("../../../static/img/headerbg.png");
						  			}
						  		if(res.data.data.pet.searchId != undefined){
						  			localStorage.setItem('publishId',res.data.data.pet.searchId); 
						  		}
						  		if(res.data.data.pet.searchId == undefined && res.data.data.search ==undefined){
						  			//console.log('是第一次发布')
						  			this.fristpublish=true;
						  		}
              	if(res.data.data.search){
              		localStorage.setItem('search','true');
              		localStorage.setItem('publishId',res.data.data.search.id);  
              		this.pagestatu = 1003;//提示已发布协寻
              		this.lossbtn = false;
              		this.closebtn = true;//协寻存在可以点击关闭
              		this.lostpetinfos = true;//协寻信息打开
              		this.lostsign = true;
              		this.losttime =res.data.data.search.loseTime;
              		localStorage.setItem('content',res.data.data.search.content);
              		localStorage.setItem('lossTime',res.data.data.search.loseTime);
              		//alert('协寻返回走失地点：'+res.data.data.search.lostPlace)
              		localStorage.setItem('lostPlace',res.data.data.search.lostPlace);
              		this.featurePhoto =[];
              		this.featurePhoto=JSON.parse(res.data.data.search.featurePhoto);
              		localStorage.setItem('title','false');
              		localStorage.setItem('mytagchang','mytagchang');//告诉子组件读取存储信息
              	}else{
              		this.pagestatu = 1001;//提示看好宠物
              		this.lossbtn = true;
              		this.closebtn = false;
              		localStorage.setItem('search','false');
              		localStorage.setItem('lostPlace',this.myplace);
              	}
              	localStorage.setItem('petId',res.data.data.pet.petId);
              	localStorage.setItem('Id',res.data.data.pet.id);
             }else{
					      this.$alert("<p>" + this.$t("prompt.tokenfailure") + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });	
  		}
  	},
//====展示我不是主人协寻信息===
  	showfindinfo(){
  		if(localStorage.codeId){
  				let code = localStorage.codeId;
  				var params = Qs.stringify({
							deviceCode: code,
					});
					index(params)
			    .then(res => {
							//console.log("我不是主人查看协寻返回数据：",res);
              if (res.data.header.status == 1000) {
              	  this.ifedit = false;//宠物信息是否可以编辑
						  		this.isable = true;//禁止编辑主人信息
						  		this.menus = false;
						  		if(res.data.data.pet.portrait==''){
						  			this.portrait=require("../../../static/img/headerbg.png")
						  			}
              	if(res.data.data.search){
              		this.addScanner();//增加扫码记录
              		this.pagestatu = 1002;//提示宠物丢失，请帮忙
              		this.lossbtn = false;
              		this.closebtn = false;//协寻存在可以点击关闭
              		this.lostpetinfos = true;//协寻信息打开
              		this.lostsign = true;
              		this.losttime =res.data.data.search.loseTime;
              		localStorage.setItem('content',res.data.data.search.content);
              		localStorage.setItem('lossTime',res.data.data.search.loseTime);
              		localStorage.setItem('lostPlace',res.data.data.search.lostPlace);
              		//alert('协寻返回走失地点：'+res.data.data.search.lostPlace)
              		this.featurePhoto =[];
              		this.featurePhoto=JSON.parse(res.data.data.search.featurePhoto);
              		localStorage.setItem('title','false');
              		localStorage.setItem('mytagchang','mytagchang');//告诉子组件读取存储信息
              	}else{
              		this.pagestatu = 1001;//提示看好宠物
              		this.lossbtn = false;
              		this.closebtn = false;
              	}
             }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });	
  		}
  	},
//获取url参数=========
  	GetQueryString(name){
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  unescape(r[2]); return null;
		},
//绑定用户=========
		bind(){
					let code =localStorage.codeId
					var params = Qs.stringify({
						code:code,
					});
					bind(params)
			    .then(res => {
						//console.log("绑定设备返回数据：",res);
			      if (res.data.header.status == 1000) {
							console.log('绑定设备成功！')
			      }else{
				      this.$alert("<p>" + res.data.header.message + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
								});
							return false;
			      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
	    
		},
//解除绑定用户=========
		unbind(){
					let code =localStorage.codeId//获取吊牌id
					var params = Qs.stringify({
						code:code,
					});
					unbind(params)
			    .then(res => {
					//console.log("解除绑定设备返回数据：",res);
			      if (res.data.header.status == 1000) {
							console.log('解除绑定设备成功！')
			      }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
	    
		},
//添加宠物========
		add_pet(){
					var gender;
					if(this.value=='公'||this.value=='boy'){
						gender='male'
					}else{
						gender='female'
					}
					var params = Qs.stringify({
							name: this.petname,
	            height: this.height,
	            weight: this.weight,
	            birthTime: this.birthday,
	            petType: this.petbelong,
	            color: this.color,
	            gender: gender,
	            portrait: this.portrait,
	            character: this.character
					});
					add_pet(params)
			    .then(res => {
							//console.log("添加宠物返回数据：",res);
              if (res.data.header.status == 1000) {
                this.ifedit = false;
                this.portrait = res.data.data.portrait;
                this.petId = res.data.data.petId;
                this.Id = res.data.data.id;
 								localStorage.setItem('Id',this.Id);
                this.bind_pet();//绑定宠物
              }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });	
		},
//绑定宠物=======
		bind_pet(){
					let code =localStorage.codeId//获取吊牌id
					var params = Qs.stringify({
					    deviceCode:code,
         			petId:this.petId,	
					});
					bind_pet(params)
			    .then(res => {
						//console.log("绑定宠物返回数据：",res);
			      if (res.data.header.status == 1000) {
							console.log('绑定宠物成功！')
			      }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
//修改用户基本信息====
		updateBasicInfo(){
						if(this.nc==''|| !this.nc){
							this.$alert("<p>" + this.$t("mynewsedit.EnterMastername") + "</p>", {
							confirmButtonText: this.$t("prompt.sure"),
							dangerouslyUseHTMLString: true
							});
							return false;
						}
						if(this.em==''||this.em==undefined){this.em=''}
						if(this.phone==''||this.phone==undefined){this.phone=''}
						if(this.adr==''||this.adr==undefined){this.adr=''}
					var params = Qs.stringify({
						nickname : this.nc,
		  			email : this.em,
		  			mobile : this.phone,
		  			address : this.adr,   
		  			sex:"0",
					});
					updateBasicInfo(params)
			    .then(res => {
						//console.log("修改用户返回数据：",res);
			      if (res.data.header.status == 1000) {
							//console.log('修改用户基本信息成功！')
			      }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
//关闭协寻信息=======
		updatePublish(){
					var params = Qs.stringify({
					    publishId:localStorage.publishId,
         			isOpen:0,	
					});
					updatePublish(params)
			    .then(res => {
						//console.log("修改协寻信息返回数据：",res);
			      if (res.data.header.status == 1000) {
			      	localStorage.setItem('search','');
								this.pagestatu = 1001;//提示看好宠物
	          		this.lossbtn = true;
	          		this.closebtn = false;//协寻存在可以点击关闭
	          		this.lostpetinfos = false;//协寻信息关闭
	          		this.lostsign = false;
	          	this.$alert("<p>" + this.$t("mysearch.closed") + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
							});
							this.reload();
			      }else{
					      this.$alert("<p>" + res.data.header.message + "</p>", {
									confirmButtonText: this.$t("prompt.sure"),
									dangerouslyUseHTMLString: true
									});
								return false;
				      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
//更新宠物信息=======
		updatePet(){
			if(!this.Id){//修改信息时判断当前宠物id是否存在
				this.Id= localStorage.Id;
			}
			//判断图片是否为base64格式
			if(this.portrait1.indexOf('http://') != -1){
				this.portrait1 = '';
			}
			
			if(this.petname==''){
				this.$alert("<p>" + this.$t("addpet.entername") + "</p>", {
					confirmButtonText: this.$t("prompt.sure"),
					dangerouslyUseHTMLString: true
					});
					return false;
			}else{
					var reg = /^[0-9a-zA-Z\u4e00-\u9fa5 ]+$/;
					if(!reg.test(this.petname)){
						this.$alert("<p>" + this.$t("prompt.contentInteval") + "</p>", {
						confirmButtonText: this.$t("prompt.sure"),
						dangerouslyUseHTMLString: true
						});
						this.reload();
						return false;
					}
			}
			var gender;
			if(this.value=='公'||this.value=='boy'){
				gender='male'
			}else{
				gender='female'
			}
			var params = Qs.stringify({
					id:this.Id,
			   	name: this.petname,
	        petType: this.petbelong,
	        gender: gender,
	        portrait: this.portrait1,
			});
			updatePet(params)
		    .then(res => {
		      if (res.data.header.status == 1000) {
						//console.log('更新宠物信息成功！',res.data)
						this.petname = res.data.data.name;
						this.petbelong = res.data.data.petType;
						this.petType = res.data.data.petType;
						
						if(res.data.data.gender=='male'){
							this.gender=this.$t("prompt.boy");
							this.label=this.$t("prompt.boy");
						}else{
							this.gender=this.$t("prompt.girl");
							this.label=this.$t("prompt.girl");
						}					
						if(res.data.data.portrait==''){
		  				this.portrait=require("../../../static/img/headerbg.png")
		  			}else{
		  				this.portrait = res.data.data.portrait;
		  			}
		      }else{
		      this.$alert("<p>" + res.data.header.message + "</p>", {
						confirmButtonText: this.$t("prompt.sure"),
						dangerouslyUseHTMLString: true
						});
					return false;
	      }
		    })
		    .catch(error => {
		      console.log(error);
		    });
		},
//=====获取位置成功后发布
		onpublish(){
			//alert('进入发布程序...')
			if(!this.petId){//修改信息时判断当前id是否存在
				this.petId= localStorage.petId;
			}
  		this.email = this.em;
  		this.mobile = this.phone;
			this.getNowFormatDate();//发布时间
			if(this.myplace==''){
				this.myplace=localStorage.newlostPlace;
			}
			var params = Qs.stringify({
			    title:this.$t("releaseSearch.title"),
 					content:this.$t("releaseSearch.decription"),
 					lat:this.lat,
 					lon:this.lng,	
 					mobile:this.mobile,
 					email:this.email,	
 					loseTime:this.losttime,
 					lostPlace:this.myplace,	
 					bounty:"1000",
 					petId:this.petId,
			});
			addPublish(params)
	    .then(res => {
	      if (res.data.header.status == 1000) {
	      	this.loadimg=false;//登录成功加载图片消失
	      	localStorage.setItem('search','true');
					this.lostpetinfos = true;
		  		this.lostsign = true;
					this.lossbtn = false;
					this.closebtn = true;
		  		this.pagestatu = 1003;
		  		this.petname = this.petname;
		  		this.petType = this.petbelong;//获取品种
		  		this.gender = this.value;
		  		this.nickname = this.nc;
		  		this.address = this.adr;//主人输入的地方
		  		this.fristpublish=false;
		  		localStorage.setItem('lostPlace',res.data.data.lostPlace);
					localStorage.setItem('publishId',res.data.data.id); 
					this.$alert("<p>" + this.$t("mysearch.success") + "</p>", {
						confirmButtonText: this.$t("prompt.sure"),
						dangerouslyUseHTMLString: true
						});
	      }else{
	      	this.loadimg=false;//登录成功加载图片消失
		      this.$alert("<p>" + res.data.header.message + "</p>", {
						confirmButtonText: this.$t("prompt.sure"),
						dangerouslyUseHTMLString: true
						});
					return false;
	      }
	    })
	    .catch(error => {
	      console.log(error);
	    });
		},
//=======关闭发布
		closepublish(){
			this.updatePublish();//关闭并解绑协寻信息
		},
//=======获取url指定参数
		GetUrlParam(paraName){
		　　　　var url = document.location.toString();
		　　　　var arrObj = url.split("?");
		　　　　if (arrObj.length > 1) {
		　　　　　　var arrPara = arrObj[1].split("&");
		　　　　　　var arr;
		　　　　　　for (var i = 0; i < arrPara.length; i++) {
		　　　　　　　　arr = arrPara[i].split("=");
		　　　　　　　　if (arr != null && arr[0] == paraName) {
		　　　　　　　　　　return arr[1];
		　　　　　　　　}
		　　　　　　}
		　　　　　　return "";
		　　　　}
		　　　　else {
		　　　　　　return "";
		　　　　}
		　　},
//获取当前时间
	  	getNowFormatDate() {	  
		  	var date = new Date();
		  	var year = date.getFullYear();
		  	var month = date.getMonth() + 1;
		  	var strDate = date.getDate();
		  	if (month >= 1 && month <= 9) {
		   	 month = "0" + month;
		  	}
		  	if (strDate >= 0 && strDate <= 9) {
		    strDate = "0" + strDate;
		  	}
    			var h =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +":";
      		var m =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      		var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
		  	var currentdate = year + '-' + month + '-' + strDate +' ' + h + m + s;
		  	this.losttime = currentdate;
		  	localStorage.setItem('lossTime',this.losttime)
		},
//=====添加扫码记录=========
		addScanner(){
					var date = new Date();
			  	var year = date.getFullYear();
			  	var month = date.getMonth() + 1;
			  	var strDate = date.getDate();
			  	if (month >= 1 && month <= 9) {
			   	 month = "0" + month;
			  	}
			  	if (strDate >= 0 && strDate <= 9) {
			    strDate = "0" + strDate;
			  	}
    			var h =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +":";
      		var m =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
      		var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
			  	var currentdate = year + '-' + month + '-' + strDate +' ' + h + m + s;
			  	console.log(currentdate)
					var time3 = new Date(currentdate.replace(/\-/g, '/')).getTime();
					console.log(time3)
					let codeid =localStorage.codeId//获取吊牌id
					var geolocation = new BMap.Geolocation();
					geolocation.getCurrentPosition(
					      function(r) {
					        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
					          var params = Qs.stringify({
											    id:codeid,
											    time:time3,
											    lat:r.point.lat,
						 							lon:r.point.lng,	
											});
											addScanner(params)
									    .then(res => {
									      if (res.data.header.status == 1000) {
									      }else{
										      this.$alert("<p>" + res.data.header.message + "</p>", {
														confirmButtonText: this.$t("prompt.sure"),
														dangerouslyUseHTMLString: true
														});
													return false;
							      		}
									    })
									    .catch(error => {
									      console.log(error);
									    });
					        } else {
					          alert("failed" + this.getStatus());
					        }
					      },
					      {
					        enableHighAccuracy: true
					      }
					);
		},
//发布走失地点定位
    mapready(){
    		//alert('开始获取定位...')
    		this.loadimg=true;
        var th = this;
        var map = new BMap.Map("allmap");
        var geolocation = new BMap.Geolocation();
        var geoc = new BMap.Geocoder();
        geolocation.getCurrentPosition(
            function(r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    th.lng = r.point.lng;
                    th.lat = r.point.lat;
                    geoc.getLocation(r.point, function(rs) {
                        //addressComponents对象可以获取到详细的地址信息
                        var addComp = rs.addressComponents;
                        var site =
                            addComp.province +
                            addComp.city +
                            addComp.district +
                            addComp.street +
                            addComp.streetNumber;
                        th.myplace = site;//我当前的位置
                        localStorage.setItem('newlostPlace',th.myplace);
                        th.onpublish();
                    });
                } else {
                    alert("failed" + this.getStatus());
                }
            },
            { enableHighAccuracy: true }
        );
    },
//=====菜单开口=============
  	editMenus(){
  		if(this.menu == false){
  			this.menu = true;
  			this.menuimg = require("../../../static/img/menus.png");
  		}else{
  			this.menu = false;
  			this.menuimg = require("../../../static/img/menuss.png");
  		}
  	},
//=====菜单组件-重新打开编辑效果=======
  	editInfo(info){
  	  this.lostpetinfos = info.lostpetinfos;
  		this.lostsign = info.lostsign;
  		this.lossbtn = info.lossbtn;
  		this.ifedit = info.ifedit;
  		this.isable = info.isable;
  	},
//======走失信息组件-禁止编辑效果======
  	editInfo2(info){
  	  this.lostpetinfos = info.lostpetinfos;
  		this.lostsign = info.lostsign;
  		this.lossbtn = info.lossbtn;
  		this.ifedit = info.ifedit;
  		this.isable = info.isable;
  		this.losttime= info.lossTime.split("");
  		//修改信息保存触发更新宠物
  		this.updatePet();
  	},
  	//子组件关闭菜单
  	menuClose(info){
  		this.menu = info.menuC;
  		this.scanningrecords = info.cords;
  	},
//====获取用户所有信息==========
		index(){
			setTimeout(() => {
					if(localStorage.codeId==''||localStorage.codeId==null){
						let codeid = this.GetUrlParam("deviceCode");
						localStorage.setItem('codeId',codeid);
					}
					let code = localStorage.codeId;
					var params = Qs.stringify({
						deviceCode :code,
					});
					index(params)
			    .then(res => {
						//console.log("获取后台返回数据：",res);
			      if (res.data.header.status == 1000) {
					  	this.imgflag = true;
		          this.petname = res.data.data.pet.name;
							this.petType = res.data.data.pet.type;
							this.portrait = res.data.data.pet.portrait;
							this.portrait1 = res.data.data.pet.portrait;
							this.avatar = res.data.data.pet.portrait;
							this.petbelong = res.data.data.pet.type;
							
							if(res.data.data.pet.gender=='male'){
								this.gender=this.$t("prompt.boy");
								this.value=this.$t("prompt.boy");
							}else{
								this.gender=this.$t("prompt.girl");
								this.value=this.$t("prompt.girl");
							}
							
							this.nc = res.data.data.user.nickname;
		        	this.em = res.data.data.user.email;
		        	this.phone = res.data.data.user.mobile;
		        	this.adr = res.data.data.user.address;
			        this.getuserinfo(res.data.data.user.userID);
				    }else{
				      this.$alert("<p>" + res.data.header.message + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
								});
							return false;
			      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
			}, 200);
		},	
//======获取用户信息
		getuserinfo(userID){
			var params = Qs.stringify({
					    params:'*',
					});
					getuserinfo(params)
			    .then(res => {
						//console.log("获取用户信息：",res);
			      if (res.data.header.status == 1000) {
							let userId = res.data.data.userID;
							if(userID == userId){
									//console.log("我是主人")
						  		this.tagshow();//根据我的吊牌显示内容
							}else{
								//console.log("我不是主人！")
					  		this.showfindinfo();//展示协寻信息
							}
			      }else{
				      this.$alert("<p>" + this.$t("prompt.tokenfailure") + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
								});
							return false;
	      		}
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
		//=====返回顶部==== 
		gotop(scrollY){
			if(scrollY == 0){
				setTimeout(function() {
	       	document.body.scrollTo(0, 0);
					document.documentElement.scrollTo(0, 0);
					document.getElementById('app').scrollTo(0, 0);
      	}, 100);
			}
		},
  	//扫码记录显示
		cordClose(info){
			this.scanningrecords = info.cords;
		},
		//获取宠物列表组件信息
		getpetType(data){
		    this.selpetType = false;
		    this.petbelong = data.id;
		},
		//关闭简介
		introductClose(){
			this.isintroduction = false;
		},
//=====菜单组件-重新打开编辑宠物主人信息效果=======
  	editInfo3(info){
  		this.ifedit = info.ifedit;
  		this.isable = info.isable;
  		this.lossbtn = info.lossbtn;
  		this.activations = info.activations;
  	},
//=====保存更改主人，宠物信息======
		save(){
			this.updatePet();
			this.updateBasicInfo();
			this.activations=false;
			this.lossbtn = true;
			this.ifedit=false;//宠物信息是否可以编辑
      this.isable=true;//主人信息输入框
		},
//=====取消修改=========
		cancel(){
			this.reload();
		},
		//展示简介
		showintroduct(){
			this.isintroduction = true;

		},
		//获取宠物品种
		selpetsType(isable){
			 isable = this.isable;
				if(isable == true){
					return false;
				}
		    this.selpetType = true;
		},
		//验证宠物品种
		Verificationbelong() {
		    console.log(this.petbelong)
		    if (this.petbelong=="") {
		        this.flag3 = false;
		        this.flag7 = true;
		    } else {
		        this.flag3 = false;
		        this.flag7 = false;
		    }
		},
		//改变种类
  	changepetbelong(e) {
      this.petType = e;
    },
    //改变名称
  	changename(e) {
      this.petname = e;
    },
    //验证宠物名称
    Verificationname() {
      if (this.petname.length > 0) {
        this.flag6 = false;
      }
    },
    //验证宠物品种
    Verificationbelong() {
      if (this.petType.length > 0) {
        this.flag7 = false;
      }
    },
		// 打开图片上传
    uploadHeadImg: function() {
        this.$el.querySelector(".hiddenInput").click();
    },   
    // 将头像显示
    handleFile: function(e) { 
      var th = this;
      th.imgflag = true;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
      EXIF.getData(file, function() {
        Orientation = EXIF.getTag(this, "Orientation");
      });
      if (file) {
        reader.readAsDataURL(file);
      }
      th.changeflag = true;
      reader.onload = data => {
        let res = data.target || data.srcElement;
        if (data.total < maxSize) {
          th.showflag1 = false;
          th.isshow = true;
          th.avatar = res.result;
          th.portrait1 = data.target.result.split(",")[1];
          localStorage.setItem('portrait',th.portrait1)
        } else {
          th.compress(res.result, Orientation);
        }
      };         
    },
    //图片压缩
    compress(result, Orientation) {
      var img = new Image();
      var th = this;
      img.src = result;
      th.showflag1 = true;
      th.isshow = false;
      img.onload = function() {
        var width = img.width;
        var height = img.height;
        var ratio = 400;
        if (width > ratio) {
          var scaling = 1 - (width - ratio) / width;
          width = width * scaling;
          height = height * scaling;
        }
        var canvas = th.$refs.can;
        var ctx = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        if (Orientation != "" && Orientation != 1 && Orientation != undefined) {
          switch (Orientation) {
            case 6: //需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, width, -height);
              break;
            case 8: //需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate((-90 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, 0);
              break;
            case 3: //需要180度旋转
              ctx.rotate((180 * Math.PI) / 180);
              ctx.drawImage(img, 0, 0, -width, -height);
              break;
          }
        } else {
          canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        }
        var base64 = canvas.toDataURL("image/jpeg", 1.5);
        th.portrait1 = base64.split(",")[1];
        th.avatar = base64.result;
      };
    },
//====过滤表情和特殊字符=====
    filter(substring){
		    if(substring){
		        for ( var i = 0; i < substring.length; i++) {
		            var hs = substring.charCodeAt(i);
		            if (0xd800 <= hs && hs <= 0xdbff) {
		                if (substring.length > 1) {
		                    var ls = substring.charCodeAt(i + 1);
		                    var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
		                    if (0x1d000 <= uc && uc <= 0x1f77f) {
		                        return true;
		                    }
		                }
		            } else if (substring.length > 1) {
		                var ls = substring.charCodeAt(i + 1);
		                if (ls == 0x20e3) {
		                    return true;
		                }
		            } else {
		                if (0x2100 <= hs && hs <= 0x27ff) {
		                    return true;
		                } else if (0x2B05 <= hs && hs <= 0x2b07) {
		                    return true;
		                } else if (0x2934 <= hs && hs <= 0x2935) {
		                    return true;
		                } else if (0x3297 <= hs && hs <= 0x3299) {
		                    return true;
		                } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030
		                    || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b
		                    || hs == 0x2b50) {
		                    return true;
		                }
		            }
		        }
		    }
		},

    
    
  },
  beforeUpdate() {

  },
  filters: {
    infosCmputed: function(value) {
      if (value == "TAG") return this.$t("prompt.QrCode");
    },
    lowercase: function(value) {
      return value.toLowerCase();
    }
  },
  components: {
    "v-header": header,
    "v-choosePet": choosePet,
    "v-introduction":introduction,
    "v-menus":menus,
    "v-scanningrecord":scanningrecord,
    "v-lostpetinfo":lostpetinfo,
    adddeviceType,
    addpetType
  }
};
</script>
<style>
	.pet .el-input .el-input__inner{
  border: none;
  border-color:#fff !important;
  border-bottom: solid 1px #fff;
  width: 100%;
  box-sizing: border-box;
  text-align: center !important;
  height: 1.8rem !important;
  line-height: 1.8rem !important;
  padding: 0 0.5rem 0 1rem !important;
  font-size: 0.8rem;
  border-radius: 0;
  color: #fff;
  background-color: transparent;
}
.pet .el-select,.pet .el-input{
  width: 100%;
	color: #fff;
}
.el-select .el-input .el-select__caret{
	color: #fff;
}
.el-input__icon{
	line-height: 30px;
}
.el-select .el-input .is-focus .el-input__inner{
	border-color:#fff;
}
.el-select:hover .el-input__inner {
    border-color: #fff;
}
.el-input__inner::-webkit-input-placeholder{
    color:#fff;
}
.el-input__inner:-moz-placeholder{
    color:#fff;
}
.el-input__inner::-moz-placeholder{
    color:#fff;
}
.el-input__inner:-ms-input-placeholder{
    color:#fff;
}
.loadimg{
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,.5);
	position: fixed;
	z-index: 1005;
	top: 0;
	text-align: center;
}
.loadimg img{
    width: 35px !important;
    height: 35px;
    display: inline-block;
    position: absolute;
    top: 50%;
    margin-left: -17px;
    margin-top: -17px;
}
</style>
<style scoped>

.home {
  width: 100%;
  overflow-x: hidden;
}
.home .el-button--primary { /*激活按钮*/
    width: 72%;
    margin-left: 14%;
    font-size: 1.2rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}	
img {
  width: 100%;
}
.allinfo{
	width: 100%;
	height: 100%;
	min-height: 26rem;
	background: url(../../../static/img/mainbg.png) top center #fff no-repeat;
  background-size: 100% 100%;
}
.title {
    padding-top: 1.5rem;
    padding-bottom: .5rem;
}
.title ul{
	position: relative;
}
.title ul li{
    text-align: center;
    color: #000;
    font-size: 1rem;
    font-family:PingFang SC;
}
.title ul p{
		text-align: right;
    color: #fff;
    font-size: .8rem;
    width: 35%;
    font-weight: bold;
    font-family: PingFang SC;
    height: 1rem;
    display: inline-block;
    position: absolute;
    right: 2%;
    top: -25px;
}
.title ul p img{
	    width: 1rem;
	    padding-right: 2%;
	    vertical-align: middle;
	    margin-top: -5px;
}

.device_content {
  padding: 10px;
}
.device_content .device_title,
.device_box {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 0.85rem;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}
.device_content .device_code,
.device_box .device_code {
  flex: 6;
  color: #3f3f3f;
}
.device_content .bind_pet,
.device_box .bind_pet {
  flex: 18;
  padding-left: 10px;
}
.device_box {
  padding: 10px 0;
}
.device_box .bind_pet {
  border-left: 1px solid #eee;
  display: flex;
}
.device_code img {
  width: 1.5rem;
  display: block;
  margin: 0 auto;
}
.device_code span {
  display: block;
  margin-top: 5px;
  font-size: 0.5rem;
  text-align: center;
}
.bind_pet img {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
.bind_pet span {
  padding-left: 20px;
  color: #808080;
  font-size: 1rem;
  line-height: 65px;
}


.lossbtn{
		position: absolute;
    bottom: .5rem;
    right: 0;
    text-align: center;
    height: 1.1rem;
    min-width: 3rem;
    padding-left:.5rem;
    padding-right: .5rem;
    line-height: 1.2rem;
    color: #fff;
    font-size: 0.7rem;
    border: solid 1px #fff;
    border-radius: .6rem;
}
.lostsign{
	width: 4.5rem;
	height: 4.5rem;
	position: absolute;
	top: -20px;
	right: 0;
	z-index: 22;
  transform: rotate(30deg);
}
.lostsign li{
    width: 4rem;
    height: 4rem;
		color: #e34139;
    font-size: 10px;
    display: inline-block;
    position: absolute;
    top: .3rem;
    left: .2rem;
    text-align: center; 
    transform: rotateZ(155deg);
}
.lostsign li span { position: absolute; display: inline-block; left: 0; right: 0; top: 0; bottom: 0; text-transform: uppercase; transition: all 0.5s cubic-bezier(0, 0, 0, 1); }
.lostsign li span:nth-child(1){
transform: rotateZ(0deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(2){
transform: rotateZ(15deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(3){
transform: rotateZ(30deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(4){
transform: rotateZ(45deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(5){
transform: rotateZ(60deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(6){
transform: rotateZ(75deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(7){
transform: rotateZ(90deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(8){
transform: rotateZ(105deg) translate3d(0px, 0px, 0px);		
}
.lostsign li span:nth-child(9){
transform: rotateZ(120deg) translate3d(0px, 0px, 0px);		
}
.lostsign li span:nth-child(10){
transform: rotateZ(135deg) translate3d(0px, 0px, 0px);		
}
.lostsign img{
	width: 100%;
}
/*宠物信息*/
.petinfo {
  width: 100%;
  max-width: 579px;
  height: 165px;
  position: relative;
  margin-top: 4%;
}
.petinfo .danger {
  font-size: 0.625rem;
  color: red;
  margin-top: 5px;
}

.petinfo-main {
  position: absolute;
  bottom: 0;
  width: 94%;
  height: 100%;
  margin: 0 3%;
  max-width: 579px;
  overflow: hidden;
  touch-action: none;
  background: #5dcfe5;
  border: solid 1px #f3f3f3;
	-webkit-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
	-moz-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
	box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
}
.petinfo-main:before{
	content: '';
	background:url(../../../static/img/petinfoline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
    top: 61%;
    left: 2%;
    height: 35%;
    width: 15%;
	transform: rotate(180deg);
}
.petinfo-main:after{
	content: '';
	background: url(../../../static/img/petinfoline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
		top: 5%;
    left: 83%;
    height: 69%;
    width: 15%;
}
.head_img {
    margin-top: 12%;
    margin-left: 5%;
    width: 4.5rem;
    height: 4.5rem;
    position: absolute;
    border: none;
    border-radius: 50%;
    overflow: hidden;
}
.head_img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.pet {
    width: 60%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 20px;
}
.pet ul{
  margin-top: 1rem;
}
.pet ul li{
  list-style: none;
  width: 100%;
  position: relative;
  z-index: 1;
}
.petNewsIcon{
    position: absolute;
    font-size: .5rem;
    display: block;
    height: 1.8rem;
    line-height: 1.8rem;
    z-index: 990;
    color: #fff;
}
.petNewsIcon img{
  width: .9rem;
  vertical-align: middle;
  margin: 0 0.5rem;
      margin-left: 0;
}
.el-input__prefix, .el-input__suffix{
	text-align: right;
}
.pet ul li p{
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    border-bottom: 1px solid #eaeef9;
    height: 1.8rem;
    line-height: 1.8rem;
    font-size: .8rem;
    color: #fff;
}

.pet .el-input .el-input__inner{
  border: none;
  border-color:#fff !important;
  border-bottom: solid 1px #fff;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  height: 1.8rem;
  line-height: 1.8rem;
  padding: 0 0.5rem 0 1rem;
  font-size: 0.8rem;
  border-radius: 0;
  color: #fff;
  background-color: transparent;
}
.pet .el-select,.pet .el-input{
  width: 100%;
	color: #fff;
}
.el-select .el-input .el-select__caret{
	color: #fff;
}
.el-select .el-input .is-focus .el-input__inner{
	border-color:#fff;
}
.el-select:hover .el-input__inner {
    border-color: #fff;
}
.el-input__inner::-webkit-input-placeholder{
    color:#fff;
}
.el-input__inner:-moz-placeholder{
    color:#fff;
}
.el-input__inner::-moz-placeholder{
    color:#fff;
}
.el-input__inner:-ms-input-placeholder{
    color:#fff;
}



/*主人信息*/
.mynews .el-button--primary{
background-color: rgb(9,81,150);
border-color: rgb(9,81,150);
}
.sel {
  width: 75%;
  box-sizing: border-box;
  text-align: right;
}
.sel .el-input {
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: right;
}
.sel .el-input__inner {
  border-radius: 0;
  border: 0;
  font-size: 0.8rem;
  height: 2.5rem;
  line-height: 2.5rem;
  color: #3f3f3f;
  text-align: right;
  background: transparent;
}
.mynews{
    height: 165px;
    max-width: 579px;
    width: 94%;
    position: relative;
    margin: 0 3%;
    margin-top: 6%;
    z-index: 10;
    background: #96dae7;
    border: solid 1px #f3f3f3;
		-webkit-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
		-moz-box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
		box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.5);
}
.mynews:before{
	content: '';
	background:url(../../../static/img/mynewsline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
	top: 5%;
	left: 2%;
  height: 45%;
  width: 21%;
	transform: rotate(180deg);
}
.mynews:after{
	content: '';
	background:url(../../../static/img/mynewsline.png);
	background-repeat: no-repeat;
	background-size: 100%;
	display: block;
	position: absolute;
	top: 50%;
	left: 77%;
  height: 45%;
  width: 21%;
}


.new{
    height: 100%;
    width: 70%;
    position: absolute;
    right: 15%;
}

.news{
    width: 70%;
    position: absolute;
    top: 8%;
    right: 15%;
}
.news .pos {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
}
.pos input {
  width: 96%;
  border: 0px;
  box-sizing: border-box;
  height: 1.6rem;
  line-height: 1.6rem;
  font-size: 0.8rem;
  background: transparent;
  color: #fff;
  text-align: center;
  padding-left: 15%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.pos input::-webkit-input-placeholder{
    color:#fff;
}
.pos input:-moz-placeholder{
    color:#fff;
}
.pos input::-moz-placeholder{
    color:#fff;
}
.pos input:-ms-input-placeholder{
    color:#fff;
}


.pos input:disabled {
  border-radius: 0;
  border: 0px;
  opacity: 1;
  text-align: center;
  color: #fff;
}
.pos input:focus,
.pos select:focus {
  outline: none;
}
.news span {
	position: absolute;
    font-size: .5rem;
    display: block;
    height: 1.6rem;
    line-height: 1.6rem;
    z-index: 999;
    color: #fff;
}
.news span img{
    width: .9rem;
    vertical-align: middle;
    margin: 0 0.5rem;
        margin-left: 0;
}
.denger{
  font-size: .625rem;
  margin-top: 5px;
  color: red;
}
.news .el-button {
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 30px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  padding: 0 0;
}
.hiddenInput {
  display: none;
}
.menus{
	width: 3rem;
	height: 3rem;
	position: fixed;
	right: 0;
	bottom: 0;
	z-index: 1001;
}
.menus img{
	width: 100%;
}

@media screen and (max-width: 321px) {
	.home .el-button--primary{
		margin: 1rem auto !important;
	}
	.petinfo{
		width: 100%;
    max-width: 579px;
    height: 145px;
    position: relative;
    margin-top: 4%;
	}
	.pet{
		top: 0;
	}
	.pet span{
	    font-size: 0.78rem !important;
	}
	.pet ul{
	  margin-top: 2rem;
	} 
	.title ul p{
		top: -15px;
	}
	.mynews{
		height: 145px;
		margin-top: 5%;
	}
	.news{
		top:10%;
	}
	.news span {
	  height: 1.6rem;
	  line-height: 1.6rem;
	}
	.pos input{
		height: 1.6rem;
	  line-height: 1.6rem;
	} 
	.lossbtn{
		bottom: .2rem;
	}
}
@media (min-width: 411px) and (max-width: 578px) {
	.petinfo{
		height: 180px;
	}
	.lossbtn{
		bottom: .5rem;
	}
	.mynews{
		height: 180px;
		margin-top: 5%;
	}	
	.head_img{
		margin-top: 10%;
	}
}
@media (min-width: 600px) and (max-width: 578px) {
	.petinfo{
		height: 245px;
	}
	.mynews{
		height: 245px;
	}	

}
</style>



// WEBPACK FOOTER //
// src/m_page/home/showInformation.vue